import React from "react";
import { SquaresFour, BookOpen, VideoCamera, Note, GearSix } from "@phosphor-icons/react";
import { cn } from "@/lib/utils";
import { useRouter } from "next/router";

const dockItems = [
  { href: "/dashboard", icon: SquaresFour, label: "Home" },
  { href: "/content", icon: BookOpen, label: "Subjects" },
  { href: "/classes", icon: VideoCamera, label: "Recordings" },
  { href: "/notes", icon: Note, label: "Notes" },
  { href: "/profile", icon: GearSix, label: "Settings" },
];

export default function BottomDock({ activePath }: { activePath: string }) {
  const router = useRouter();

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    router.push(href);
  };

  return (
    <nav
      className="fixed bottom-0 inset-x-0 z-50 lg:hidden bg-white dark:bg-gray-900 border-t border-gray-200 dark:border-gray-800"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
    >
      <div className="flex items-stretch h-16">
        {dockItems.map(({ href, icon: Icon, label }) => {
          const active = activePath === href;
          return (
            <a
              key={href}
              href={href}
              onClick={(e) => handleClick(e, href)}
              className="flex flex-col items-center justify-center gap-1 flex-1 py-2 transition-opacity active:opacity-70"
            >
              <span
                className={cn(
                  "flex h-8 w-8 items-center justify-center rounded-xl transition-colors",
                  active
                    ? "bg-primary-50 dark:bg-primary-900/30 text-primary dark:text-primary-300"
                    : "text-gray-400 dark:text-gray-500",
                )}
              >
                <Icon size={20} weight={active ? "bold" : "regular"} />
              </span>
              <span
                className={cn(
                  "text-[10px] font-semibold leading-none",
                  active
                    ? "text-primary dark:text-primary-300"
                    : "text-gray-400 dark:text-gray-500",
                )}
              >
                {label}
              </span>
            </a>
          );
        })}
      </div>
    </nav>
  );
}
